import React from "react";
import "./games.scss";
import MyGamesEventInfo from "../myGamesEventInfo";

const Games = () => {
  return <MyGamesEventInfo className={'user_events_container'} />;
};

export default Games;
